import {PaymentOptionType, ItemPaymentConfig} from '@wix/auto_sdk_ecom_current-cart-v-2';
import {PriceModel} from '../Price.model';
import {ModelContext} from '../../../types/app.types';

export class PaymentConfigModel {
  public savePaymentMethod: boolean;
  public depositAmount: PriceModel;
  public paymentOption: PaymentOption;

  constructor(params: PaymentConfigModel) {
    this.savePaymentMethod = params.savePaymentMethod;
    this.depositAmount = params.depositAmount;
    this.paymentOption = params.paymentOption;
  }

  public static fromCartV1({
    savePaymentMethod,
    depositAmount,
    paymentOption,
  }: {
    savePaymentMethod: boolean;
    depositAmount: PriceModel;
    paymentOption: PaymentOptionType;
  }): PaymentConfigModel {
    return new PaymentConfigModel({savePaymentMethod, depositAmount, paymentOption: paymentOptionMap[paymentOption]});
  }

  public static fromCartV2(paymentConfig: ItemPaymentConfig, modelContext: ModelContext): PaymentConfigModel {
    return new PaymentConfigModel({
      savePaymentMethod: paymentConfig.savePaymentMethod,
      depositAmount: paymentConfig.depositAmount
        ? /* istanbul ignore next */ PriceModel.fromCartV2(paymentConfig.depositAmount, modelContext)
        : undefined,
      paymentOption: paymentOptionMap[paymentConfig.paymentOption],
    });
  }
}

export enum PaymentOption {
  DEPOSIT_ONLINE = 'DEPOSIT_ONLINE',
  FULL_PAYMENT_OFFLINE = 'FULL_PAYMENT_OFFLINE',
  FULL_PAYMENT_ONLINE = 'FULL_PAYMENT_ONLINE',
  MEMBERSHIP = 'MEMBERSHIP',
  MEMBERSHIP_OFFLINE = 'MEMBERSHIP_OFFLINE',
  MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER = 'MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER',
}

const paymentOptionMap: Record<PaymentOptionType, PaymentOption> = {
  [PaymentOptionType.DEPOSIT_ONLINE]: PaymentOption.DEPOSIT_ONLINE,
  [PaymentOptionType.MEMBERSHIP]: PaymentOption.MEMBERSHIP,
  [PaymentOptionType.MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER]: PaymentOption.MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER,
  [PaymentOptionType.MEMBERSHIP_OFFLINE]: PaymentOption.MEMBERSHIP_OFFLINE,
  [PaymentOptionType.FULL_PAYMENT_OFFLINE]: PaymentOption.FULL_PAYMENT_OFFLINE,
  [PaymentOptionType.FULL_PAYMENT_ONLINE]: PaymentOption.FULL_PAYMENT_ONLINE,
};
